module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-03-13 at 04.20.27.1e0078c0.png";